import { useQuery } from "@tanstack/react-query";

import { sessionQueryKeys } from "./queryKeys";

import { GetApiInternalUser200, ModelsUser } from "@/schemas";
import { getApiInternalUser } from "@/shared/api/user";
import { createQueryOptions } from "@/shared/lib/api";

// TODO: Fix AccountInfo type to match ModelsUser from API

export const useGetUserQuery = (enabled: boolean = true) => {
    return useQuery(
        createQueryOptions<GetApiInternalUser200, ModelsUser>({
            queryKey: sessionQueryKeys.user,
            queryFn: () => getApiInternalUser(),
            preset: "static",
            select: (response) => response.data || {},
            enabled,
        }),
    );
};
